import {css} from "lit";

export const customScrollStyles = css`
	.custom-scroll-bar-light {
		/* Firefox */
		scrollbar-width: thin;
		scrollbar-color: var(--pn-color-thumb) var(--pn-color-track);
	}
	/* Webkit browsers */
	.custom-scroll-bar-light::-webkit-scrollbar {
		width: var(--pn-webkit-scrollbar-size); /* vertical scroll */
		height: var(--pn-webkit-scrollbar-size); /* horizontal scroll */
		appearance: none;
		background: var(--pn-color-track);
	}
	.custom-scroll-bar-light::-webkit-scrollbar-thumb {
		box-shadow: inset 1px 0 0 var(--pn-color-track);
		border-radius: 20px;
		border: 3px solid var(--pn-color-thumb-border);
		background-clip: content-box;
		background-color: var(--pn-color-thumb);
	}
	.custom-scroll-bar-light::-webkit-scrollbar-track {
		border-radius: 0;
		background: var(--pn-color-track);
	}

	/** TODO: start
	// For a dark colored background
	.custom-scroll-bar-dark {
		&::-webkit-scrollbar {
			width: 10px;
			.m-appearance (none);
		}

		&::-webkit-scrollbar-thumb {
			.m-box-shadow (inset 1px 0 0 @project-topic-menu-scrollbar-track-color);
			.m-rounded (20px);
			border: 3px solid @project-topic-menu-scrollbar-border-color;
			background-clip: content-box;
			background-color: @project-topic-menu-scrollbar-thumb-color;
		}

		&::-webkit-scrollbar-track {
			.m-rounded (0);
			background: transparent;
		}
	}

	.custom-scroll-bar-transparent-track {
		// Firefox
		scrollbar-width: thin;
		scrollbar-color: var(--pn-color-thumb) transparent;
	}
	// Webkit browsers
	.custom-scroll-bar-transparent-track::-webkit-scrollbar {
		width: var(--pn-webkit-scrollbar-size);
		appearance: none;
		background: transparent;
	}
	.custom-scroll-bar-transparent-track::-webkit-scrollbar-thumb {
		box-shadow: inset 1px 0 0 transparent;
		border-radius: 20px;
		border: 3px solid var(--pn-color-thumb-border);
		background-clip: content-box;
		background-color: var(--pn-color-thumb);
	}
	.custom-scroll-bar-transparent-track::-webkit-scrollbar-track {
		border-radius: 0;
		background: transparent;
	}
	TODO: end **/
`;
